import { render, staticRenderFns } from "./RequestModal.vue?vue&type=template&id=82b769b8&scoped=true"
import script from "./RequestModal.vue?vue&type=script&lang=js"
export * from "./RequestModal.vue?vue&type=script&lang=js"
import style0 from "./RequestModal.vue?vue&type=style&index=0&id=82b769b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b769b8",
  null
  
)

export default component.exports